import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyPageSeo } from './applyPageSeo';
import { getRouteSeoDefaults } from '../../config/seo';

/**
 * Applies SEO when the route has no PageMeta (e.g. bare `/` before redirect).
 */
export default function RootRedirectSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname !== '/') return;
    const defaults = getRouteSeoDefaults('/product');
    applyPageSeo({
      pathname: '/product',
      title: defaults.title,
      description: defaults.description,
      keywords: defaults.keywords,
      canonicalPath: '/product',
    });
  }, [pathname]);

  return null;
}
